import tracker from './index';

/** Canonical `seriesTabClick` names for the Bills & Income top tabs, shared by web and mobile. */
export type SeriesTabName = 'Overview' | 'CashFlow' | 'Series' | 'Refunds';

/** Canonical `seriesTabClick` subtab name for each Bills & Income series-list filter. */
export const SERIES_SUBTAB_NAMES = {
  ALL: 'All',
  INCOME: 'Income',
  BILL: 'Bills',
  SUBSCRIPTION: 'Subscriptions',
  TRANSFER: 'Transfers',
  CANCELED: 'Canceled',
  SUGGESTED: 'Suggested',
} as const;

export type SeriesSubtabFilter = keyof typeof SERIES_SUBTAB_NAMES;

/** Tracks an explicit click/press that switches to a Bills & Income top tab. */
export const trackSeriesTabClick = (tabName: SeriesTabName): void => {
  tracker.track(tracker.events.seriesTabClick, { tabName });
};

/** Tracks an explicit click/press that switches to a series-list filter subtab. */
export const trackSeriesSubtabClick = (filter: SeriesSubtabFilter): void => {
  tracker.track(tracker.events.seriesTabClick, { tabName: 'Series', subtabName: SERIES_SUBTAB_NAMES[filter] });
};
